module.exports = __webpack_public_path__ + "img/memberTwo.6821b857.svg";